import { render } from "./HalfHolidayIcon.vue?vue&type=template&id=1f7cda3c"
import script from "./HalfHolidayIcon.vue?vue&type=script&lang=js"
export * from "./HalfHolidayIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__